import { createRouter, createWebHistory } from 'vue-router'
import FrameDesktop from '../views/FrameDesktop.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'

const routes = [
  {
    path: '/',
    name: 'FrameDesktop',
    component: FrameDesktop,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPasswordView,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
